import React from "react";
import { CheckCircle } from "lucide-react";

const AboutUs = () => (
  <section className="py-24 bg-gradient-to-br from-red-50 to-red-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div className="space-y-6">
          <div className="inline-flex items-center px-4 py-2 bg-red-100 rounded-full mb-4">
            <span className="text-sm font-semibold text-red-700">
              About MenuQR
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-red-900 leading-tight">
            Empowering Restaurants Through Technology
          </h2>
          <p className="text-lg text-red-700 leading-relaxed">
            We're on a mission to help restaurants embrace digital
            transformation. Founded in 2024, MenuQR has been helping restaurants
            worldwide modernize their operations and improve customer
            experience.
          </p>
          <p className="text-lg text-red-700 leading-relaxed">
            Our platform combines cutting-edge technology with user-friendly
            design to create solutions that work for restaurants of all sizes,
            from small cafes to large restaurant chains.
          </p>
          <div className="grid grid-cols-2 gap-6 pt-6">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent mb-2">
                500+
              </h3>
              <p className="text-red-700 font-medium">Active Restaurants</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent mb-2">
                50K+
              </h3>
              <p className="text-red-700 font-medium">Orders Processed</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-10 rounded-3xl shadow-2xl">
          <h3 className="text-2xl font-bold text-red-900 mb-8">
            Our Core Values
          </h3>
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                <CheckCircle className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <h4 className="text-lg font-bold text-red-900 mb-1">
                  Innovation
                </h4>
                <p className="text-red-700">
                  Constantly improving our platform with cutting-edge features
                  and capabilities
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                <CheckCircle className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <h4 className="text-lg font-bold text-red-900 mb-1">
                  Reliability
                </h4>
                <p className="text-red-700">
                  99.9% uptime guarantee ensuring your business runs smoothly
                  24/7
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                <CheckCircle className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <h4 className="text-lg font-bold text-red-900 mb-1">Support</h4>
                <p className="text-red-700">
                  24/7 dedicated customer support whenever you need assistance
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUs;
